import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './style.scss';
import Screen from './components/Screen';
import { jsx as _jsx } from "react/jsx-runtime";
var RETRACTED_WIDTH = 5;
var CONST_PLUS = 1;

var Screens = function Screens(_ref) {
  var children = _ref.children,
      set = _ref.set,
      screens = _ref.screens,
      onCloseScreen = _ref.onCloseScreen,
      onFocusScreen = _ref.onFocusScreen,
      onOpenScreen = _ref.onOpenScreen,
      onRetractScreen = _ref.onRetractScreen,
      _ref$baseActiveWidth = _ref.baseActiveWidth,
      baseActiveWidth = _ref$baseActiveWidth === void 0 ? 40 : _ref$baseActiveWidth;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      widthState = _useState2[0],
      setWidthState = _useState2[1];

  var el = useRef();

  var resize = function resize() {
    var remSize = null;
    var pxWidth = null; //todo devicePixelRatio?
    // get available width

    if (el.current && typeof el.current.clientWidth !== 'undefined') {
      pxWidth = el.current.clientWidth;
    } // get current base font size (rem)


    if (document && document.documentElement) {
      remSize = getComputedStyle(document.documentElement).fontSize;
      remSize = Number(remSize.slice(0, -2)); // "16px" -> 16
    } // update available width in rem (if needed)


    if (pxWidth && remSize) {
      var width = pxWidth / remSize;

      if (width !== widthState) {
        setWidthState(width);
      }
    }
  };

  useEffect(function () {
    resize();
  }, []);
  useEffect(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', resize, {
        passive: true
      }); //todo IE
    }

    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', resize); //todo IE
      }
    };
  }, []);

  var renderScreen = function renderScreen(screen, content, noControls) {
    return /*#__PURE__*/_jsx(Screen, {
      lineage: screen.lineage,
      focused: screen.focused,
      disabled: screen.computedDisabled,
      width: screen.computedWidth,
      minWidth: screen.minActiveWidth,
      content: content,
      contentWidth: screen.contentWidth,
      onFocus: onFocusScreen,
      onCloseClick: onCloseScreen,
      onOpenClick: onOpenScreen,
      onRetractClick: onRetractScreen,
      noControls: noControls
    }, screen.lineage);
  };

  var renderScreens = function renderScreens() {
    if (widthState && set) {
      var screensLocal = {};
      var orderByHistory = [set.orderByHistory].reverse();

      var orderBySpace = _toConsumableArray(set.orderBySpace); // add any possible children as first screen


      if (children) {
        if (!_.includes(orderByHistory, 'base')) {
          orderByHistory.push('base');
        }

        if (!_.includes(orderBySpace, 'base')) {
          orderBySpace.unshift('base');
        }
      } // compute open screens


      var overallRetractedWidth = orderByHistory.length * RETRACTED_WIDTH;
      var availableWidthLeft = widthState - overallRetractedWidth; // check if there is enough space for first open screen

      var maximalizedScreenLineage = null;
      var baseFirstOpen = false;
      var otherFirstOpen = false;
      orderByHistory.forEach(function (lineage) {
        screensLocal[lineage] = {
          lineage: lineage
        };
        var stateScreen = screens[lineage];

        if (!maximalizedScreenLineage && !baseFirstOpen && !otherFirstOpen) {
          if (stateScreen && stateScreen.data && stateScreen.data.desiredState === 'open') {
            // screen does not fit
            if (stateScreen.data.width + CONST_PLUS > availableWidthLeft + RETRACTED_WIDTH) {
              maximalizedScreenLineage = stateScreen.lineage;
            } else {
              otherFirstOpen = true;
            }
          }

          if (lineage === 'base') {
            baseFirstOpen = true;
          }
        }

        if (stateScreen && stateScreen.data && stateScreen.data.desiredState === 'closing') {
          availableWidthLeft += RETRACTED_WIDTH;
        }
      });

      if (!maximalizedScreenLineage) {
        var focusedScreenAlreadySelected = false;
        orderByHistory.forEach(function (lineage) {
          var stateScreen = screens[lineage];

          if (!availableWidthLeft) {
            screensLocal[lineage].computedWidth = RETRACTED_WIDTH;
            screensLocal[lineage].computedDisabled = true;
          } else {
            if (stateScreen && stateScreen.data && stateScreen.data.width) {
              if (stateScreen.data.desiredState === 'open') {
                if (stateScreen.data.width + CONST_PLUS <= availableWidthLeft + RETRACTED_WIDTH) {
                  screensLocal[lineage].computedWidth = stateScreen.data.width + CONST_PLUS;
                } else {
                  screensLocal[lineage].computedWidth = availableWidthLeft + RETRACTED_WIDTH;
                  screensLocal[lineage].computedDisabled = true;
                }

                availableWidthLeft -= screensLocal[lineage].computedWidth - RETRACTED_WIDTH;
              } else if (stateScreen.data.desiredState === 'retracted') {
                screensLocal[lineage].computedWidth = RETRACTED_WIDTH;
                screensLocal[lineage].computedDisabled = true;
              } else if (stateScreen.data.desiredState === 'opening') {
                screensLocal[lineage].computedWidth = 0;
                screensLocal[lineage].computedDisabled = false;
                availableWidthLeft -= stateScreen.data.width - RETRACTED_WIDTH;
              } else {
                screensLocal[lineage].computedWidth = 0;
                screensLocal[lineage].computedDisabled = true;
              }
            } else {
              if (stateScreen && stateScreen.data && stateScreen.data.desiredState === 'retracted') {
                screensLocal[lineage].computedWidth = RETRACTED_WIDTH;
                screensLocal[lineage].computedDisabled = true;
              } else if (stateScreen && stateScreen.data && stateScreen.data.desiredState === 'closing') {
                screensLocal[lineage].computedWidth = 0;
                screensLocal[lineage].computedDisabled = true;
              } else {
                var enoughSpaceAvailable = baseActiveWidth + CONST_PLUS <= availableWidthLeft + RETRACTED_WIDTH;

                if (lineage === 'base' && (baseFirstOpen || enoughSpaceAvailable)) {
                  screensLocal[lineage].computedWidth = baseActiveWidth + CONST_PLUS;
                  availableWidthLeft -= baseActiveWidth - RETRACTED_WIDTH;
                } else {
                  screensLocal[lineage].computedWidth = availableWidthLeft + RETRACTED_WIDTH;
                  availableWidthLeft = 0;
                }

                if (lineage === 'base' && !baseFirstOpen) {
                  screensLocal[lineage].computedDisabled = screensLocal[lineage].computedWidth < baseActiveWidth;
                }
              }
            }
          }

          var closing = stateScreen && stateScreen.data.desiredState === 'closing';

          if (!focusedScreenAlreadySelected && (closing || !screensLocal[lineage].computedDisabled)) {
            screensLocal[lineage].focused = true;
            focusedScreenAlreadySelected = true;
          }
        });
      } else {
        orderByHistory.forEach(function (lineage) {
          if (lineage !== maximalizedScreenLineage) {
            screensLocal[lineage].computedDisabled = true;
            screensLocal[lineage].computedWidth = 0;
          } else {
            screensLocal[lineage].computedWidth = widthState;
            screensLocal[lineage].focused = true;
            screensLocal[lineage].minActiveWidth = 0;
          }
        });
      }

      var screenComponents = [];
      orderBySpace.forEach(function (screenLineage) {
        var screen = screensLocal[screenLineage];
        var stateScreen = screens[screenLineage];

        if (stateScreen && stateScreen.data && (stateScreen.data.minActiveWidth || screen.minActiveWidth)) {
          // screen.minActiveWidth = screen.hasOwnProperty('minActiveWidth')
          screen.minActiveWidth = Object.hasOwn(screen, 'minActiveWidth') ? screen.minActiveWidth : stateScreen.data.minActiveWidth;
        }

        if (stateScreen && stateScreen.data && stateScreen.data.width) {
          screen.contentWidth = stateScreen.data.width ? stateScreen.data.width : null;
        }

        if (screenLineage === 'base') {
          var content = children;

          if (screen.computedDisabled) {
            content = /*#__PURE__*/React.cloneElement(children, {
              unfocusable: true
            });
          }

          screenComponents.push(renderScreen(screen, content, true));
        } else {
          screenComponents.push(renderScreen(screen, /*#__PURE__*/React.createElement(stateScreen.data.component, _objectSpread(_objectSpread({}, stateScreen.data.props), {}, {
            unfocusable: screen.computedDisabled
          }), null)));
        }
      });
      return screenComponents;
    } else if (children) {
      var screen = {
        lineage: 'base'
      };
      return renderScreen(screen, children, true);
    } else {
      return null;
    }
  };

  return /*#__PURE__*/_jsx("div", {
    className: "ptr-screens",
    ref: el,
    children: renderScreens()
  });
};

Screens.propTypes = {
  set: PropTypes.shape({
    orderBySpace: PropTypes.array,
    orderByHistory: PropTypes.array
  }),
  screens: PropTypes.object,
  onCloseScreen: PropTypes.func,
  onFocusScreen: PropTypes.func,
  onOpenScreen: PropTypes.func,
  onRetractScreen: PropTypes.func,
  baseActiveWidth: PropTypes.number,
  children: PropTypes.node
};
export default Screens;